import { render, staticRenderFns } from "./riskMonitor.vue?vue&type=template&id=678dcb5e&scoped=true"
import script from "./riskMonitor.vue?vue&type=script&lang=js"
export * from "./riskMonitor.vue?vue&type=script&lang=js"
import style0 from "./riskMonitor.vue?vue&type=style&index=0&id=678dcb5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678dcb5e",
  null
  
)

export default component.exports